import { APP_ID, Component, Input, OnInit } from '@angular/core';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { FAQ } from 'src/app/models/um/organization';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-faq-view',
  templateUrl: './faq-view.component.html',
  styleUrls: ['./faq-view.component.scss']
})
export class FaqViewComponent implements OnInit {
  faqs: FAQ[];
  appID:any;
  @Input() Content:any;
  userType: any;
  userDetails: any;
  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    private userService: UserService,
    public modalRef: NgbActiveModal,
    public headerService: HeadService
  ) { }

  ngOnInit() {
     
    this.faqs = [];
    let modulename = "";
    this.userType = this.userService.getUserType();
    this.userDetails = this.userService.getUserDetais();
    this.appID = this.Content.content.AppID;
    let module = this.headerService.getHeader().subscribe((result)=>{
      modulename=result.module;
      this.GetModuleFAQs(modulename, this.appID);
    });

  }
  GetModuleFAQs(modulename:string, AppID : string)
  {
    this.summaryService.getFAQByID('api/faq/getwffaqs/' + modulename + '/' + AppID).subscribe((result) => {
      if(result)
      {
        result.forEach(element => {
          if(element.TARGET_USER_TYPE == this.userType || element.TARGET_USER_TYPE == "B")
          {
            this.faqs.push(element)
          }
        });
      }



    });
  }

}
